import React, { useEffect } from "react";
import { DocumentMagnifyingGlassIcon } from "@heroicons/react/24/outline";

function TesteBusca(props) {
  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <section>
      <div className="container col-md-11">
        <div className="row content section paddingt-2 white-background">
          <div className="col-md-12">
            <nav aria-label="breadcrumb" role="navigation">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active">Resultados da Pesquisa</li>
              </ol>
            </nav>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="col-md-8 ">
            <h1 style={{ display: "flex", justifyContent: "center" }}>
              <DocumentMagnifyingGlassIcon className = "icon-title-size" />Resultados da
              Pesquisa
            </h1>
            <hr />

            <p className="content" style={{ display: 'flex', justifyContent: 'center' }}>
              Não encontrou o que precisa ? entre em contato pelo chat!
            </p>

            <br></br>

            <ul className="nav flex-column articles-listing ">
              {props.searchResults && props.searchResults.length > 0 ? (
                props.searchResults.map((result) => (
                  <li className="faq-item">
                    <a href={`${result.item.url}`}>
                      <h3>{result.item.titulo}</h3>
                    </a>
                    <p>{result.item.descricao}</p>
                  </li>
                ))
              ) : (
                <li className="faq-item">Nenhum resultado encontrado.</li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TesteBusca;
